import styled from '@emotion/styled';
import {colors} from '../styles';
import breakpoints from '../styles/breakpoints';

export const Layout = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-wrap: no-wrap;
  flex-direction: column;
  ${breakpoints.largeAndUp`flex-direction: row;`};
`;

export const MainContent = styled.div`
  flex: 1;
  height: 100%;
  overflow: ${props => (props.overflowHidden ? 'hidden' : 'auto')};
  background-color: ${colors.lightestGray};
  -webkit-overflow-scrolling: touch;
`;
